import { useEffect, useMemo, useRef, useState } from 'react'
import { getInitialViewByWidth, MAPBOX_TOKEN, mapStyle } from './utils'
import MapGL, { MapProvider, NavigationControl, FullscreenControl, Source, Layer } from 'react-map-gl/mapbox'
import ControlGeocoder from './components/control-geocoder'
import Tooltip from './components/tooltip'

import {
	dadesPerCusec,
	rendaMin,
	rendaMax,
	rendaSource,
	rendaLayer,
	rendaOutlineLayer,
	rendaBeforeId,
} from './rendaLayer'
import textos from './assets/textos.json'
import 'mapbox-gl/dist/mapbox-gl.css'
import '@common/reset.css'
import './style.scss'

export default function App({ embedHome, lang, slug }) {
	const containerRef = useRef(null)
	const [containerSize, setContainerSize] = useState({ width: 0, height: 0 })
	const [hoverInfo, setHoverInfo] = useState(null)
	const rendaFormat = useMemo(
		() => new Intl.NumberFormat(lang === 'es' ? 'es-ES' : 'ca-ES', { maximumFractionDigits: 0 }),
		[lang],
	)
	const handleMouseMove = (event) => {
		const feature = event.features?.[0]
		const cusec = String(feature?.properties?.CUSEC ?? '')
			.trim()
			.padStart(10, '0')
		const dades = dadesPerCusec.get(cusec)
		setHoverInfo(dades ? { longitude: event.lngLat.lng, latitude: event.lngLat.lat, dades } : null)
	}
	const initialViewState = useMemo(() => {
		if (!containerSize.width || !containerSize.height) {
			return null
		}

		return getInitialViewByWidth(containerSize.width, containerSize.height)
	}, [containerSize.width, containerSize.height])

	useEffect(() => {
		if (!containerRef.current) {
			return
		}

		const updateContainerSize = () => {
			const rect = containerRef.current?.getBoundingClientRect?.()
			setContainerSize({
				width: rect?.width ?? 0,
				height: rect?.height ?? 0,
			})
		}

		updateContainerSize()

		const resizeObserver = new ResizeObserver(updateContainerSize)
		resizeObserver.observe(containerRef.current)

		return () => {
			resizeObserver.disconnect()
		}
	}, [])

	return (
		<MapProvider>
			<div className='container-mapa' ref={containerRef}>
				{initialViewState && (
					<MapGL
						id='mapa_renda_catalunya'
						mapboxAccessToken={MAPBOX_TOKEN}
						projection='mercator'
						initialViewState={initialViewState}
						style={{
							position: 'absolute',
							width: '100%',
							height: '100%',
						}}
						mapStyle={mapStyle}
						attributionControl={false}
						cooperativeGestures={true}
						reuseMaps
						locale={textos[lang]?.mapbox}
						interactiveLayerIds={[rendaLayer.id]}
						onMouseMove={handleMouseMove}
						onMouseLeave={() => setHoverInfo(null)}
					>
						<Source {...rendaSource}>
							<Layer {...rendaLayer} beforeId={rendaBeforeId} />
							<Layer {...rendaOutlineLayer} beforeId={rendaBeforeId} />
						</Source>
						<Tooltip hoverInfo={hoverInfo} lang={lang} textos={textos[lang]?.tooltip} />
						<ControlGeocoder accessToken={MAPBOX_TOKEN} />
						<FullscreenControl position='bottom-right' />
						<NavigationControl showZoom showCompass={false} />
					</MapGL>
				)}
				<div className='llegenda-renda'>
					<div className='llegenda-renda__valors'>
						<span>{rendaFormat.format(rendaMin)}€</span>
						<span>{rendaFormat.format(rendaMax)}€</span>
					</div>
					<div className='llegenda-renda__escala' />
				</div>
			</div>

			{/* <p className='font' dangerouslySetInnerHTML={{ __html: textos[lang]?.font }} /> */}
		</MapProvider>
	)
}
